var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29.687,
    viewBox: "0 0 29 29.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M3.409,1.745a1.645,1.645,0,0,0-1.174.5,1.738,1.738,0,0,0,0,2.4L13.9,16.589,2.235,28.531a1.738,1.738,0,0,0,0,2.4,1.634,1.634,0,0,0,2.349,0L16.253,18.993,27.921,30.934a1.664,1.664,0,0,0,1.174.5,1.625,1.625,0,0,0,1.174-.5,1.738,1.738,0,0,0,0-2.4L18.6,16.589,30.27,4.647a1.738,1.738,0,0,0,0-2.4,1.643,1.643,0,0,0-2.348,0L16.253,14.185,4.584,2.243a1.645,1.645,0,0,0-1.174-.5Z",
    transform: "translate(-1.752 -1.745)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdCloseIcon);
export default __webpack_public_path__ + "static/media/md-close-icon.c2129ff92b0893b09eaebfb30a3ccafb.svg";
export { ForwardRef as ReactComponent };